export default __webpack_public_path__ + "images/83e1b651c217100d567d5f313562716e.png";